/* Tyler Long Studios — gallery layer motion. No dependencies. */
(() => {
  if (window.__tlsGallery) return;
  window.__tlsGallery = true;
  const doc = document.documentElement;
  doc.classList.add('tls-js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function markReveals(root = document) {
    // product cards in grids get a staggered reveal
    $$('.product-grid__item, .resource-list__item', root).forEach((el, i) => {
      if (el.hasAttribute('data-tls-reveal')) return;
      el.setAttribute('data-tls-reveal', '');
      el.style.setProperty('--tls-delay', (i % 4) * 90 + 'ms');
    });
    $$('media-gallery', root).forEach((el) => el.classList.add('tls-watch'));
    $$('[data-tls-reveal], .tls-watch', root).forEach((el) => {
      if (reduce || !io) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- Peace mark on the homepage hero ---------- */
  function addStamp() {
    const main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    const hero = main.querySelector('.shopify-section');
    if (!hero || hero.querySelector('.tls-stamp')) return;
    const target = hero.querySelector('.hero, [class*="hero"]') || hero;
    if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
    const wrap = document.createElement('div');
    wrap.className = 'tls-stamp';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = '<span class="tls-stamp__core">☮</span>';
    target.appendChild(wrap);
  }

  /* ---------- Manifesto: words light up as you scroll ---------- */
  const manifestos = [];
  function setupManifestos() {
    $$('[data-tls-manifesto]').forEach((sec) => {
      if (sec.__tls) return;
      sec.__tls = true;
      const words = $$('.w', sec);
      manifestos.push({ sec, words });
    });
  }
  function updateManifestos() {
    const vh = window.innerHeight;
    manifestos.forEach(({ sec, words }) => {
      const r = sec.getBoundingClientRect();
      const prog = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height * 0.75)));
      const n = words.length;
      words.forEach((w, i) => {
        const t = Math.min(1, Math.max(0, prog * n - i));
        w.style.opacity = reduce ? 1 : (0.12 + t * 0.88).toFixed(3);
      });
      if (prog > 0.85) sec.classList.add('is-drawn');
    });
  }

  /* ---------- Drag to scroll for the gallery wall ---------- */
  function setupDrag() {
    $$('[data-tls-drag]').forEach((rail) => {
      if (rail.__tls) return;
      rail.__tls = true;
      let down = false, sx = 0, sl = 0, moved = false;
      rail.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft;
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - sx;
        if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
        rail.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', () => { down = false; rail.classList.remove('is-dragging'); });
      rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Scroll loop (works whether the window or the theme wrapper scrolls) ---------- */
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { updateManifestos(); ticking = false; });
  }
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  function init(root) {
    markReveals(root);
    addStamp();
    setupManifestos();
    setupDrag();
    updateManifestos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // Re-run when the theme swaps content (filters, sorting, editor changes)
  if ('MutationObserver' in window) {
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; init(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();